module.exports = __webpack_public_path__ + "img/visit_step2_img.277587db.png";